export default __webpack_public_path__ + "static/accenture-hero-new-5717757c1b5c0c30b0bf0f00e8e45f4c.jpg";